import { render, staticRenderFns } from "./DownloadStatus.vue?vue&type=template&id=bc575716&scoped=true"
import script from "./DownloadStatus.vue?vue&type=script&lang=js"
export * from "./DownloadStatus.vue?vue&type=script&lang=js"
import style0 from "./DownloadStatus.vue?vue&type=style&index=0&id=bc575716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc575716",
  null
  
)

export default component.exports